var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzalea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 33,
    viewBox: "0 0 149 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4121 17.0938V10.0938",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4121 10.8438C16.8263 10.8438 17.1621 10.508 17.1621 10.0938C17.1621 9.67954 16.8263 9.34375 16.4121 9.34375C15.9979 9.34375 15.6621 9.67954 15.6621 10.0938C15.6621 10.508 15.9979 10.8438 16.4121 10.8438Z",
    fill: "#112F5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4121 13.3438C18.8263 13.3438 19.1621 13.008 19.1621 12.5938C19.1621 12.1795 18.8263 11.8438 18.4121 11.8438C17.9979 11.8438 17.6621 12.1795 17.6621 12.5938C17.6621 13.008 17.9979 13.3438 18.4121 13.3438Z",
    fill: "#112F5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4121 13.3438C14.8263 13.3438 15.1621 13.008 15.1621 12.5938C15.1621 12.1795 14.8263 11.8438 14.4121 11.8438C13.9979 11.8438 13.6621 12.1795 13.6621 12.5938C13.6621 13.008 13.9979 13.3438 14.4121 13.3438Z",
    fill: "#112F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4121 12.5938L16.4121 17.0938L14.4121 12.5938",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4129 17.0946L9.75586 14.9316",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75586 15.6816C10.1701 15.6816 10.5059 15.3459 10.5059 14.9316C10.5059 14.5174 10.1701 14.1816 9.75586 14.1816C9.34165 14.1816 9.00586 14.5174 9.00586 14.9316C9.00586 15.3459 9.34165 15.6816 9.75586 15.6816Z",
    fill: "#112F5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.5508C13.1642 14.5508 13.5 14.215 13.5 13.8008C13.5 13.3866 13.1642 13.0508 12.75 13.0508C12.3358 13.0508 12 13.3866 12 13.8008C12 14.215 12.3358 14.5508 12.75 14.5508Z",
    fill: "#112F5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5137 18.3555C11.9279 18.3555 12.2637 18.0197 12.2637 17.6055C12.2637 17.1913 11.9279 16.8555 11.5137 16.8555C11.0995 16.8555 10.7637 17.1913 10.7637 17.6055C10.7637 18.0197 11.0995 18.3555 11.5137 18.3555Z",
    fill: "#112F5D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 13.8027L16.4112 17.0947L11.5137 17.6067",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4114 17.0938L12.2969 22.7572",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2988 23.5078C12.713 23.5078 13.0488 23.172 13.0488 22.7578C13.0488 22.3436 12.713 22.0078 12.2988 22.0078C11.8846 22.0078 11.5488 22.3436 11.5488 22.7578C11.5488 23.172 11.8846 23.5078 12.2988 23.5078Z",
    fill: "#112F5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1499 20.3076C12.5638 20.3076 12.8994 19.972 12.8994 19.5581C12.8994 19.1442 12.5638 18.8086 12.1499 18.8086C11.736 18.8086 11.4004 19.1442 11.4004 19.5581C11.4004 19.972 11.736 20.3076 12.1499 20.3076Z",
    fill: "#112F5D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3862 22.6592C15.8002 22.6592 16.1357 22.3236 16.1357 21.9097C16.1357 21.4957 15.8002 21.1602 15.3862 21.1602C14.9723 21.1602 14.6367 21.4957 14.6367 21.9097C14.6367 22.3236 14.9723 22.6592 15.3862 22.6592Z",
    fill: "#112F5D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1504 19.5588L16.4129 17.0938L15.3864 21.9097",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4121 17.0938L20.5266 22.7572",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5273 23.5078C20.9416 23.5078 21.2773 23.172 21.2773 22.7578C21.2773 22.3436 20.9416 22.0078 20.5273 22.0078C20.1131 22.0078 19.7773 22.3436 19.7773 22.7578C19.7773 23.172 20.1131 23.5078 20.5273 23.5078Z",
    fill: "#112F5D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.439 22.6592C17.8529 22.6592 18.1885 22.3236 18.1885 21.9097C18.1885 21.4957 17.8529 21.1602 17.439 21.1602C17.025 21.1602 16.6895 21.4957 16.6895 21.9097C16.6895 22.3236 17.025 22.6592 17.439 22.6592Z",
    fill: "#112F5D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6753 20.3076C21.0892 20.3076 21.4248 19.972 21.4248 19.5581C21.4248 19.1442 21.0892 18.8086 20.6753 18.8086C20.2613 18.8086 19.9258 19.1442 19.9258 19.5581C19.9258 19.972 20.2613 20.3076 20.6753 20.3076Z",
    fill: "#112F5D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4396 21.9097L16.4121 17.0938L20.6756 19.5583",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4121 17.0946L23.0691 14.9316",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0684 15.6797C23.4826 15.6797 23.8184 15.3439 23.8184 14.9297C23.8184 14.5155 23.4826 14.1797 23.0684 14.1797C22.6541 14.1797 22.3184 14.5155 22.3184 14.9297C22.3184 15.3439 22.6541 15.6797 23.0684 15.6797Z",
    fill: "#112F5D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3105 18.3555C21.7248 18.3555 22.0605 18.0197 22.0605 17.6055C22.0605 17.1913 21.7248 16.8555 21.3105 16.8555C20.8963 16.8555 20.5605 17.1913 20.5605 17.6055C20.5605 18.0197 20.8963 18.3555 21.3105 18.3555Z",
    fill: "#112F5D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0737 14.5517C20.4877 14.5517 20.8232 14.2162 20.8232 13.8022C20.8232 13.3883 20.4877 13.0527 20.0737 13.0527C19.6598 13.0527 19.3242 13.3883 19.3242 13.8022C19.3242 14.2162 19.6598 14.5517 20.0737 14.5517Z",
    fill: "#112F5D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3096 17.6053L16.4121 17.0938L20.0731 13.8008",
    stroke: "#112F5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2325 9.9065C11.037 9.418 10.918 8.9395 10.918 8.537C10.918 6.7445 11.8165 6.815 12.416 6.019C13.0155 5.223 13.195 3.5 14.414 3.5C15.1035 3.5 15.2235 4.0335 16.412 4.0335C17.6005 4.0335 17.7205 3.5 18.41 3.5C19.629 3.5 19.8085 5.2225 20.408 6.0185C21.0065 6.8145 21.906 6.744 21.906 8.5365C21.906 8.9395 21.786 9.418 21.5915 9.906",
    stroke: "#112F5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02515 19.8492C7.50065 19.8792 7.01615 19.8492 6.63665 19.7232C4.94815 19.1697 5.29265 18.3282 4.72865 17.5067C4.15915 16.6857 2.59115 15.9807 2.97065 14.8122C3.18065 14.1527 3.72465 14.1977 4.08965 13.0647C4.45865 11.9267 3.98915 11.6392 4.20415 10.9792C4.57915 9.81121 6.26265 10.1687 7.19615 9.84121C8.12965 9.51471 8.33965 8.62721 10.0332 9.18671C10.4132 9.30721 10.8272 9.56921 11.2322 9.90621",
    stroke: "#112F5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02457 19.8477C7.58007 20.1292 7.21007 20.4417 6.97557 20.7692C5.92657 22.2197 6.70107 22.6937 6.72057 23.6957C6.74107 24.6927 5.88157 26.1937 6.86607 26.9142C7.42457 27.3217 7.83507 26.9647 8.79857 27.6647C9.75757 28.3697 9.54257 28.8782 10.1021 29.2812C11.0856 30.0062 12.2351 28.7172 13.1841 28.4302C14.1321 28.1427 14.8171 28.7322 15.8656 27.2817C16.1011 26.9547 16.2806 26.4962 16.4106 25.9817",
    stroke: "#112F5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7931 19.8477H24.7981C25.2426 20.1292 25.6116 20.4417 25.8461 20.7692C26.8961 22.2197 26.1216 22.6937 26.1021 23.6902C26.0816 24.6927 26.9411 26.1937 25.9566 26.9137C25.3971 27.3212 24.9876 26.9642 24.0291 27.6642C23.0701 28.3692 23.2801 28.8727 22.7206 29.2807C21.7361 30.0057 20.5876 28.7167 19.6386 28.4297C18.6896 28.1372 18.0056 28.7317 16.9561 27.2812C16.7216 26.9542 16.5421 26.4957 16.4121 25.9812",
    stroke: "#112F5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5918 9.90661C21.9963 9.56911 22.4113 9.30761 22.7898 9.18211C24.4833 8.62761 24.6933 9.51461 25.6278 9.84111C26.5613 10.1686 28.2448 9.81111 28.6198 10.9791C28.8338 11.6391 28.3638 11.9266 28.7343 13.0596C29.0993 14.1976 29.6433 14.1526 29.8533 14.8121C30.2323 15.9806 28.6648 16.6856 28.1003 17.5066C27.5298 18.3281 27.8798 19.1691 26.1873 19.7231C25.8073 19.8491 25.3228 19.8791 24.7988 19.8491H24.7938",
    stroke: "#112F5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2324 9.90625L12.4519 11.6003",
    stroke: "#112F5D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 19.8438L10.0033 19.1973",
    stroke: "#112F5D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4102 25.9866L16.4112 23.8926",
    stroke: "#112F5D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7953 19.8472L22.8203 19.1992",
    stroke: "#112F5D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5935 9.9082L20.373 11.6017",
    stroke: "#112F5D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0561 30.5H40.8441L50.3121 4.328H54.6681L64.1721 30.5H59.8881L57.6561 24.236H47.2881L45.0561 30.5ZM51.9681 11.06L48.4761 20.744H56.4681L52.9761 11.06C52.8801 10.748 52.7721 10.436 52.6521 10.124C52.5561 9.788 52.4961 9.512 52.4721 9.296C52.4241 9.512 52.3521 9.788 52.2561 10.124C52.1841 10.436 52.0881 10.748 51.9681 11.06ZM79.7916 30.5H65.7876V27.332L74.9316 16.064H65.7876V12.824H79.7916V15.992L70.5396 27.26H79.7916V30.5ZM88.534 30.968C86.662 30.968 85.186 30.464 84.106 29.456C83.05 28.448 82.522 27.14 82.522 25.532C82.522 23.9 83.086 22.604 84.214 21.644C85.366 20.66 86.986 20.084 89.074 19.916L94.51 19.484V19.052C94.51 18.14 94.342 17.42 94.006 16.892C93.67 16.34 93.214 15.944 92.638 15.704C92.062 15.464 91.39 15.344 90.622 15.344C89.254 15.344 88.198 15.62 87.454 16.172C86.71 16.724 86.338 17.504 86.338 18.512H83.026C83.026 17.24 83.338 16.148 83.962 15.236C84.61 14.3 85.522 13.58 86.698 13.076C87.874 12.548 89.242 12.284 90.802 12.284C92.338 12.284 93.658 12.56 94.762 13.112C95.89 13.64 96.754 14.444 97.354 15.524C97.978 16.604 98.29 17.96 98.29 19.592V30.5H94.942L94.582 27.764C94.174 28.724 93.418 29.504 92.314 30.104C91.21 30.68 89.95 30.968 88.534 30.968ZM89.758 27.98C91.222 27.98 92.386 27.548 93.25 26.684C94.114 25.796 94.546 24.608 94.546 23.12V22.148L90.442 22.508C89.002 22.628 87.97 22.94 87.346 23.444C86.746 23.948 86.446 24.584 86.446 25.352C86.446 26.24 86.734 26.9 87.31 27.332C87.886 27.764 88.702 27.98 89.758 27.98ZM106.571 30.5H102.683V3.86H106.571V30.5ZM118.961 30.968C117.209 30.968 115.661 30.572 114.317 29.78C112.997 28.988 111.953 27.896 111.185 26.504C110.441 25.088 110.069 23.468 110.069 21.644C110.069 19.796 110.429 18.176 111.149 16.784C111.893 15.392 112.925 14.3 114.245 13.508C115.565 12.692 117.089 12.284 118.817 12.284C120.545 12.284 122.033 12.656 123.281 13.4C124.553 14.12 125.537 15.152 126.233 16.496C126.953 17.816 127.313 19.376 127.313 21.176V22.472L112.121 22.508L112.193 19.988H123.425C123.425 18.62 123.005 17.54 122.165 16.748C121.349 15.932 120.233 15.524 118.817 15.524C117.737 15.524 116.813 15.752 116.045 16.208C115.301 16.664 114.725 17.348 114.317 18.26C113.933 19.148 113.741 20.24 113.741 21.536C113.741 23.552 114.185 25.088 115.073 26.144C115.985 27.2 117.305 27.728 119.033 27.728C120.281 27.728 121.313 27.488 122.129 27.008C122.945 26.528 123.473 25.82 123.713 24.884H127.349C126.941 26.78 125.993 28.268 124.505 29.348C123.041 30.428 121.193 30.968 118.961 30.968ZM135.806 30.968C133.934 30.968 132.458 30.464 131.378 29.456C130.322 28.448 129.794 27.14 129.794 25.532C129.794 23.9 130.358 22.604 131.486 21.644C132.638 20.66 134.258 20.084 136.346 19.916L141.782 19.484V19.052C141.782 18.14 141.614 17.42 141.278 16.892C140.942 16.34 140.486 15.944 139.91 15.704C139.334 15.464 138.662 15.344 137.894 15.344C136.526 15.344 135.47 15.62 134.726 16.172C133.982 16.724 133.61 17.504 133.61 18.512H130.298C130.298 17.24 130.61 16.148 131.234 15.236C131.882 14.3 132.794 13.58 133.97 13.076C135.146 12.548 136.514 12.284 138.074 12.284C139.61 12.284 140.93 12.56 142.034 13.112C143.162 13.64 144.026 14.444 144.626 15.524C145.25 16.604 145.562 17.96 145.562 19.592V30.5H142.214L141.854 27.764C141.446 28.724 140.69 29.504 139.586 30.104C138.482 30.68 137.222 30.968 135.806 30.968ZM137.03 27.98C138.494 27.98 139.658 27.548 140.522 26.684C141.386 25.796 141.818 24.608 141.818 23.12V22.148L137.714 22.508C136.274 22.628 135.242 22.94 134.618 23.444C134.018 23.948 133.718 24.584 133.718 25.352C133.718 26.24 134.006 26.9 134.582 27.332C135.158 27.764 135.974 27.98 137.03 27.98Z",
    fill: "#112F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzalea);
export default __webpack_public_path__ + "static/media/azalea.93251f850f719a7392fb1c4db3bbf4d4.svg";
export { ForwardRef as ReactComponent };